import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserDomainService} from '../user-domain.service';
import {UserDomain} from '../user-domain';

@Component({
  selector: 'app-user-domains-chooser',
  templateUrl: './user-domains-chooser.component.html',
  styleUrls: ['./user-domains-chooser.component.scss']
})
export class UserDomainsChooserComponent implements OnInit {

  @Input()
  id?: number;

  @Input()
  height?: any;

  @Output()
  valueChange = new EventEmitter<number>();

  selectedDomain?: UserDomain;
  domains: UserDomain[];
  hasSingleDomain: boolean;

  constructor(
    private userDomainsService: UserDomainService,
  ) {

    // User domains
    this.domains = userDomainsService.domains;
    this.selectedDomain = userDomainsService.selectedDomain();
    this.hasSingleDomain = userDomainsService.hasSingleDomain();
  }

  ngOnInit(): void {
  }

  save(e: any) {
    this.valueChange.emit(this.id);
  }

}
